/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { OutUserDTO } from "./OutUserDTO";
import { OutUserDTOFromJSON, OutUserDTOFromJSONTyped, OutUserDTOToJSON } from "./OutUserDTO";

/**
 *
 * @export
 * @interface UserListResponseDTO
 */
export interface UserListResponseDTO {
  /**
   *
   * @type {number}
   * @memberof UserListResponseDTO
   */
  total: number;
  /**
   *
   * @type {Array<OutUserDTO>}
   * @memberof UserListResponseDTO
   */
  users?: Array<OutUserDTO>;
}

/**
 * Check if a given object implements the UserListResponseDTO interface.
 */
export function instanceOfUserListResponseDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "total" in value;

  return isInstance;
}

export function UserListResponseDTOFromJSON(json: any): UserListResponseDTO {
  return UserListResponseDTOFromJSONTyped(json, false);
}

export function UserListResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserListResponseDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    total: json["total"],
    users: !exists(json, "users") ? undefined : (json["users"] as Array<any>).map(OutUserDTOFromJSON)
  };
}

export function UserListResponseDTOToJSON(value?: UserListResponseDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    total: value.total,
    users: value.users === undefined ? undefined : (value.users as Array<any>).map(OutUserDTOToJSON)
  };
}
